export const styles = {
  moreHorizontalIconButton: {
    width: "1px",
    display: "flex",
    justifyContent: "right",
    zIndex: 1000,
  } as const,
};
